import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { DropdownContent, DropdownItem, dropDownStore, Scrollbar, SpinnerLoader } from 'shared/ui'
import { useIntegrationDropdownContext } from 'widgets/IntegrationDropdown/context/integrationDropdownContext'
import styles from '../styles.module.scss'

type IPhoneFieldContentProps = {
  dropdownId: string
  onCloseMenu: () => void
}

export const PhoneFieldContent: FC<IPhoneFieldContentProps> = observer(
  ({ dropdownId, onCloseMenu }) => {
    const { phoneFieldLoading, phoneFieldsItems, setPhoneField } = useIntegrationDropdownContext()

    if (phoneFieldLoading) {
      return (
        <DropdownContent>
          <div className={styles.loader}>
            <SpinnerLoader ariaLabel={'PhoneFieldContent'} size={20} />
          </div>
        </DropdownContent>
      )
    }

    return (
      <DropdownContent>
        <Scrollbar
          autoHeight
          autoHeightMin={0}
          autoHeightMax={335}
          onScroll={() => {
            dropDownStore.allHide(dropdownId)
          }}
        >
          {phoneFieldsItems.map((phoneField) => (
            <DropdownItem
              key={phoneField.id}
              item={{ ...phoneField }}
              onChange={(phoneField) => {
                setPhoneField(phoneField)
                onCloseMenu()
              }}
            />
          ))}
          {!phoneFieldsItems.length && <div className={styles.noResult}>No phone fields</div>}
        </Scrollbar>
      </DropdownContent>
    )
  }
)
